module.exports = __webpack_public_path__ + "img/solution3-1.f161ccb9.png";